import script from "./BookingDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingDemo.vue?vue&type=script&setup=true&lang=js"

import "./BookingDemo.vue?vue&type=style&index=0&id=66a55692&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a55692"]])

export default __exports__